import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <i className="fas fa-cut"></i>
              <span>Igele Beauty Salon</span>
            </div>
            <p>Premium beauty services in Port Harcourt. We enhance your natural beauty with professional care and attention to detail.</p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><i className="fab fa-facebook-f"></i></a>
              <a href="#" aria-label="Instagram"><i className="fab fa-instagram"></i></a>
              <a href="#" aria-label="Twitter"><i className="fab fa-twitter"></i></a>
              <a href="#" aria-label="WhatsApp"><i className="fab fa-whatsapp"></i></a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Frontal Installation</a></li>
              <li><a href="#services">Braids & Styling</a></li>
              <li><a href="#services">Nails & Manicure</a></li>
              <li><a href="#services">Head Massage</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-item">
              <i className="fas fa-map-marker-alt"></i>
              <span>No9 Cross Crescent, Rumuibekwe Port Harcourt</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-phone"></i>
              <span>08147859422</span>
            </div>
            <div className="contact-item">
              <i className="fas fa-envelope"></i>
              <span>info@igelebeautysalon.com</span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 Igele Beauty Salon. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;